import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, colors, typography, rem } from '../../styles';
import StyledType from '../type/type.styles';
var labelStyles = function labelStyles() {
  return /*#__PURE__*/css("color:", colors.coolGray_900, ";display:block;line-height:1.2;margin-bottom:", rem(8), ";padding-right:", rem(5.28), ";position:relative;text-align:left;white-space:normal;>", StyledType, "{font-size:", typography.typographyBodySm, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:labelStyles;"));
};
var resetStyles = getResetByTag('label');
var StyledLabel = /*#__PURE__*/_styled('label', process.env.NODE_ENV === "production" ? {
  target: "etxlv0k0"
} : {
  target: "etxlv0k0",
  label: "StyledLabel"
})(resetStyles, labelStyles);
export default StyledLabel;